import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: #1a1a1a;
    --color-secondary: #4a4a4a;
    --color-accent: #c8a97e;
    --color-background: #ffffff;
    --color-text: #333333;
    --color-light: #f8f8f8;
    --font-primary: 'Playfair Display', serif;
    --font-secondary: 'Montserrat', sans-serif;
    --transition: all 0.3s ease;
    --shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--font-secondary);
    font-size: 1.6rem;
    line-height: 1.7;
    color: var(--color-text);
    background-color: var(--color-background);
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-primary);
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2rem;
    color: var(--color-primary);
  }

  h1 {
    font-size: 4.8rem;
  }

  h2 {
    font-size: 3.6rem;
  }

  h3 {
    font-size: 2.8rem;
  }

  h4 {
    font-size: 2.4rem;
  }

  p {
    margin-bottom: 2rem;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: var(--transition);
  }

  a:hover {
    color: var(--color-accent);
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    cursor: pointer;
    font-family: var(--font-secondary);
    transition: var(--transition);
  }

  ul {
    list-style: none;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .section {
    padding: 8rem 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 5rem;
  }

  .section-title h2 {
    position: relative;
    display: inline-block;
    padding-bottom: 1rem;
  }

  .section-title h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 8rem;
    height: 2px;
    background-color: var(--color-accent);
  }

  @media (max-width: 768px) {
    html {
      font-size: 55%;
    }
    
    .section {
      padding: 6rem 0;
    }
  }

  @media (max-width: 576px) {
    html {
      font-size: 50%;
    }
    
    .section {
      padding: 4rem 0;
    }
  }
`;

export default GlobalStyles;
